import { render } from "./ServicePage.vue?vue&type=template&id=85215ef0&scoped=true"
const script = {}

import "./ServicePage.vue?vue&type=style&index=0&id=85215ef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85215ef0"]])

export default __exports__